import React from 'react';
export const Loading = () => (React.createElement("div", { className: "Loading" },
    React.createElement("div", { className: "Loading__spinner" },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null))));
